import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Input, Row } from "reactstrap";
import { getJobPrefixLoading, getJobsheetTatLoading, getJobsheetTrend } from "src/store/actions";
import 'bootstrap/dist/css/bootstrap.min.css'
import { RootReducerState } from "src/store/reducers";
import DropdownInput from "src/components/UI/DropdownInput";
import { Form, Formik } from "formik";
import InputCom from "src/components/Common/Input";
import Button from "src/components/UI/Button";
import { LazyTableState } from "src/models/components/dataTableWrapperModel";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { formatDateTOYYYYMMDD } from "src/helpers/common_helpers";
import { Column } from "primereact/column";
import UIButton from 'src/components/UI/Button'
import { Link } from "react-router-dom";
import { ROUTER } from "src/constants/routes";

interface TrendProps {
  date?: any
  realDate?: any
}

const convertTimesToSeconds = (seconds: any) => {
  let years = Math.floor(seconds / (60 * 60 * 24 * 365));
  seconds %= (60 * 60 * 24 * 365);
  let months = Math.floor(seconds / (60 * 60 * 24 * 30));
  seconds %= (60 * 60 * 24 * 30);
  let days = Math.floor(seconds / (60 * 60 * 24));
  seconds %= (60 * 60 * 24);
  let hours = Math.floor(seconds / (60 * 60));
  seconds %= (60 * 60);
  let minutes = Math.floor(seconds / 60);
  let remainingSeconds = seconds % 60;
  let output = [];
  if (years > 0) {
    output.push(`${years} year${years > 1 ? 's' : ''}`);
  }
  if (months > 0) {
    output.push(`${months} month${months > 1 ? 's' : ''}`);
  }
  if (days > 0) {
    output.push(`${days} day${days > 1 ? 's' : ''}`);
  }
  if (hours > 0) {
    output.push(`${hours} hour${hours > 1 ? 's' : ''}`);
  }
  if (minutes > 0) {
    output.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
  }
  if (remainingSeconds > 0) {
    output.push(`${remainingSeconds.toFixed(1)} second${remainingSeconds > 1 ? 's' : ''}`);
  }
  if (output.length === 0) {
    return "";
  } else {
    return output.join(", ");
  }
};

const JobsheetTat = ({ date, realDate }: TrendProps) => {
  const dispatch = useDispatch();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(new Date().getDate() - 7);
  const filterDetails: DataTableFilterMeta = {
    JobCreationStartDate: { value: formatDateTOYYYYMMDD(sevenDaysAgo), matchMode: "contains" },
    JobCreationEndDate: { value: formatDateTOYYYYMMDD(new Date()), matchMode: "contains" },
    JobPrefix:{value:"all",matchMode:"contains"},
    type:{value:"all",matchMode:"contains"}
  };
  const { jobsheetTatValue,jobPrefixList } = useSelector((state: RootReducerState) => state.dashboard);

  const [ tatStatus,setTatStatus]=useState("all")

  const [openFor,setOpenFor]=useState<any>({
    mount:false,
    dealer:false,
    supplier:false,
    courier:false,
    nonpending:false,
    open:false,
    closed:false,
  })

  const jobTatValue = useMemo(()=>{
    if(tatStatus == "closed"){
      return jobsheetTatValue?.filter((data:any)=>data?.status == "Franchise Job Completed" || data?.status == "Ready To Invoice"|| data?.status == "Invoiced Job"|| data?.status == "Job Closed")
    }else if(tatStatus == "open"){
      return jobsheetTatValue?.filter((data:any)=>data?.status != "Franchise Job Completed" && data?.status != "Ready To Invoice" && data?.status != "Invoiced Job" && data?.status != "Job Closed")
    }else{
      return jobsheetTatValue;
    }
  },[jobsheetTatValue,tatStatus])

  const [key, setKey] = useState(0);
  
  useEffect(() => {
    setKey((prevKey) => prevKey + 1); // Update the key to force re-render
  }, [jobTatValue]);

  useEffect(()=>{
    dispatch(getJobPrefixLoading())
  },[])
  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 5000,
    page: 1,
    sortField: "CreationTime",
    sortOrder: -1,
    filters: filterDetails,
  };

  const [lazyState, setLazyState] = useState<any>(initialLazyState);
  const [filteredTableData, setFilteredTableData] = useState(jobTatValue);
  const [filteredChartData, setFilteredChartData] = useState([]);

  const filterJobTatData =(jobType: string, bucketLabel: string) => {
    
    // setOpenFor({
    //   mount:false,
    //   dealer:false,
    //   supplier:false,
    //   courier:false,
    //   nonpending:false,
    //   open:false,
    //   closed:false,
    //   totalClose:true,
    // })
    
    const bucket = buckets.find(b => b.label === bucketLabel);
    if (!bucket) return;
    
    const filtered = [...(filteredChartData.length>0 ? filteredChartData : jobTatValue)]?.filter((item: any) => {
      const hoursMatch = bucket.condition(item.totalHours);
  
      if (jobType === 'Exchange') {
        return item.isExchange === true && hoursMatch && item.technicianUserType != "Franchise";
      }
  
      if (jobType === 'Remote') {
        return (item.technicianUserType == "Franchise" || item.jobType == "Remote") && hoursMatch;
      }
  
      if (jobType === 'InHouse') {
        return item.technicianUserType != "Franchise" && hoursMatch && (item.jobType == "InHouse" || !item.jobType) && item.isExchange != true;
      }
  
      return item.jobType === jobType && item.isExchange != true && hoursMatch;
    });
  
    console.log('Filtered Data:', filtered);
    setFilteredTableData(filtered); // Assume you have a state like const [filteredTableData, setFilteredTableData] = useState([])
  }
const [chartSeries,setChartSeries]=useState<any>([])
const options:any ={
    chart: {
      type: 'bar',
      stacked: true,
      stackType: 'normal',
      height: 350,
      events: {
        dataPointSelection: (event: any, chartContext: any, config: any) => {
          const seriesIndex = config.seriesIndex; // 0 - In House, 1 - Exchange, 2 - Field
          const dataPointIndex = config.dataPointIndex; // 0 - 144 hours, 1 - 144 hours, etc.
  
          const selectedJobType = ['InHouse', 'Exchange', 'Remote'][seriesIndex];
          const selectedBucket = [
            '⬆️ 144 Hours',
            '144 Hours',
            '96 Hours',
            '72 Hours',
            '48 Hours',
            '24 Hours',
          ][dataPointIndex];
  
          // Now filter your jobTatValue based on these
          filterJobTatData(selectedJobType, selectedBucket);
        },
      },
    
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 10,
            style: {
              fontSize: '12px',
              fontWeight: 400,
            },
          },
        },
      },
    },
    xaxis: {
      categories: [
        '⬆️ 144 Hours',
        '144 Hours',
        '96 Hours',
        '72 Hours',
        '48 Hours',
        '24 Hours',
      ],
    },
    dataLabels: {
      enabled: true,
    },
    // colors: ['#f4a261', '#e76f51', '#6a040f'],
    colors: ['#4B9FE1', '#EF476F', '#0edf7f'],
    legend: {
      position: 'top',
    },
  };



  const buckets = [
    { label: '⬆️ 144 Hours', condition: (hours: number) => hours > 144 },
    { label: '144 Hours', condition: (hours: number) => hours <= 144 && hours > 96 },
    { label: '96 Hours', condition: (hours: number) => hours <= 96 && hours > 72 },
    { label: '72 Hours', condition: (hours: number) => hours <= 72 && hours > 48 },
    { label: '48 Hours', condition: (hours: number) => hours <= 48 && hours > 24 },
    { label: '24 Hours', condition: (hours: number) => hours <= 24 },
  ];

  
  const series =['InHouse', 'Exchange', 'Remote'].map((jobType) => {
    
    const data = buckets.map((bucket) => {
      return [...(filteredChartData.length>0 ? filteredChartData : jobTatValue)]?.filter((item: any) => {
        const hoursMatch = bucket.condition(item.totalHours);
  
        if (jobType === 'Exchange') {
          return item.isExchange == true && hoursMatch && item.technicianUserType != "Franchise";
        }
  
        if (jobType === 'Remote') {
          return (item.technicianUserType == "Franchise" || item.jobType == "Remote") && hoursMatch;
        }
  
        if (jobType === 'InHouse') {
          return item.technicianUserType != "Franchise" && hoursMatch && (item.jobType == "InHouse") && item.isExchange != true;
        }
  
        return item.jobType === jobType && item.isExchange != true && hoursMatch;
      }).length || 0;
    });
  
    return {
      name: jobType === 'InHouse' ? 'In House' : jobType == "Remote" ? "Field" : jobType,
      data,
    };
  });
  
useEffect(()=>{
  setChartSeries(series)
},[jobTatValue,filteredChartData])

const onCardClick = (type:any) => {
  setOpenFor((prevState:any) => ({
    ...prevState,
    [type]: !prevState[type],
    totalClose:false,
  }));
}

const closedStatus = ["Franchise Job Completed", "Ready To Invoice", "Invoiced Job", "Job Closed"]

useEffect(() => {

  // If none of the filters are active, show all data
  if (!openFor.mount && !openFor.dealer && !openFor.supplier && !openFor.courier && !openFor.nonpending && !openFor.open && !openFor.closed && !openFor.totalClose) {
    setFilteredTableData(jobTatValue);
    setFilteredChartData([])
    setKey((prev)=>prev+1)
    return;
  }else if(openFor.totalClose){
    return
  }

  // Filter based on active states
  const filtered = jobTatValue?.filter((data: any) => {
    return (
      (openFor.mount && data?.inPending === true && data?.pendingReason === "mel" && !closedStatus.includes(data.status)) ||
      (openFor.dealer && data?.inPending === true && (data?.pendingReason === "customer" || data?.pendingReason === "dealer") && !closedStatus.includes(data.status)) ||
      (openFor.supplier && data?.inPending === true && data?.pendingReason === "supplier" && !closedStatus.includes(data.status)) ||
      (openFor.courier && data?.inPending === true && data?.pendingReason === "courier" && !closedStatus.includes(data.status)) ||
      (openFor.nonpending && data?.inPending == false && !data?.pendingReason && !closedStatus.includes(data.status)) ||
      (openFor.open && data?.status != "Franchise Job Completed" && data?.status != "Ready To Invoice" && data?.status != "Invoiced Job" && data?.status != "Job Closed") ||
      (openFor.closed && (data?.status == "Franchise Job Completed" || data?.status == "Ready To Invoice" || data?.status == "Invoiced Job" || data?.status == "Job Closed"))
    );
  });
  setFilteredChartData(filtered)
  setFilteredTableData(filtered);
  setKey((prev)=>prev+1)
}, [openFor,jobTatValue]);


  let dummyData =useMemo(()=>{
    return [
      {
          name:"Total Calls",
          count:jobsheetTatValue?.length,
          icon:"bx-pie-chart-alt-2"
      },
    ...((tatStatus == "closed" || tatStatus == "all") ? [ {
          name:"Total Closed Call",
          count:jobTatValue?.filter((data:any)=>data?.status == "Franchise Job Completed" || data?.status == "Ready To Invoice" || data?.status == "Invoiced Job" || data?.status == "Job Closed")?.length,
          icon:"bx-window-close",
          onClick:jobTatValue?.filter((data:any)=>data?.status == "Franchise Job Completed" || data?.status == "Ready To Invoice" || data?.status == "Invoiced Job" || data?.status == "Job Closed")?.length > 0 ? ()=>onCardClick("closed") : ()=>{},
          active:openFor.closed
      }] : []),
    ...((tatStatus == "open" || tatStatus == "all") ? [  {
      name:"Total Open Call",
      count:jobTatValue?.filter((data:any)=>data?.status != "Franchise Job Completed" && data?.status != "Ready To Invoice" && data?.status != "Invoiced Job" && data?.status != "Job Closed")?.length,
      icon:"bx-check-circle",
      onClick:jobTatValue?.filter((data:any)=>data?.status != "Franchise Job Completed" && data?.status != "Ready To Invoice" && data?.status != "Invoiced Job" && data?.status != "Job Closed")?.length > 0 ?  ()=>onCardClick("open") : ()=>{},
      active:openFor.open
  }] : []),
      {
          name:"Open for mount",
          count:tatStatus == "closed" ? 0 : jobTatValue?.filter((data:any)=>data?.inPending == true && data?.pendingReason == "mel" && !closedStatus.includes(data.status))?.length,
          icon:"bx-user-circle",
          onClick:(tatStatus == "closed" || (jobTatValue?.filter((data:any)=>data?.inPending == true && data?.pendingReason == "mel" && !closedStatus.includes(data.status))?.length<1)) ? ()=>{} : ()=>onCardClick("mount"),
          active:openFor.mount
      },
      {
          name:"Open for Dealer/Customer",
          count:tatStatus == "closed" ? 0 : jobTatValue?.filter((data:any)=>data?.inPending == true && (data?.pendingReason == "customer" || data?.pendingReason == "dealer") && !closedStatus.includes(data.status))?.length,
          icon:"bx-user-check",
          onClick:(tatStatus == "closed" || (jobTatValue?.filter((data:any)=>data?.inPending == true && (data?.pendingReason == "customer" || data?.pendingReason == "dealer") && !closedStatus.includes(data.status))?.length < 1)) ? ()=>{} : ()=>onCardClick("dealer"),
          active:openFor.dealer
      },
      {
          name:"Open for Supplier",
          count:tatStatus == "closed" ? 0 : jobTatValue?.filter((data:any)=>data?.inPending == true && data?.pendingReason == "supplier" && !closedStatus.includes(data.status))?.length,
          icon:"bx-walk",
          onClick:(tatStatus == "closed" || (jobTatValue?.filter((data:any)=>data?.inPending == true && data?.pendingReason == "supplier" && !closedStatus.includes(data.status))?.length < 1)) ? ()=>{} : ()=>onCardClick("supplier"),
          active:openFor.supplier
      },
      {
          name:"Open for Courier",
          count:tatStatus == "closed" ? 0 : jobTatValue?.filter((data:any)=>data?.inPending == true && data?.pendingReason == "courier" && !closedStatus.includes(data.status))?.length,
          icon:"bx-package",
          onClick:(tatStatus == "closed" || (jobTatValue?.filter((data:any)=>data?.inPending == true && data?.pendingReason == "courier" && !closedStatus.includes(data.status))?.length < 1)) ? ()=>{} : ()=>onCardClick("courier"),
          active:openFor.courier
      },
      {
          name:"Pending Free",
          count:tatStatus == "closed" ? 0 : jobTatValue?.filter((data:any)=>data?.inPending == false && !data?.pendingReason && !closedStatus.includes(data.status))?.length,
          icon:"bx-package",
          onClick:(tatStatus == "closed" || (jobTatValue?.filter((data:any)=>data?.inPending == false && !data?.pendingReason && !closedStatus.includes(data.status))?.length < 1)) ? ()=>{} : ()=>onCardClick("nonpending"),
          active:openFor.nonpending
      },
    ]
  },[jobTatValue,lazyState,openFor,tatStatus])

  const handleSubmit =(values:any)=>{
    setFilteredTableData([])
    setFilteredChartData([])
    setOpenFor({
      mount:false,
      dealer:false,
      supplier:false,
      courier:false,
      nonpending:false,
      open:false,
      closed:false,
      totalClose:true,
    })
    if(values.type == "openCall"){
      setTatStatus("open")
    }else if(values.type == "closedCall"){
      setTatStatus("closed")
    }else if(values.type == "all"){
      setTatStatus("all")
    }
    setLazyState((prev:any)=>{
      return{
        ...prev,
        filters:{
          ...prev.filters,
          JobCreationStartDate:{value:values.JobCreationStartDate},
          JobCreationEndDate:{value:values.JobCreationEndDate},
          JobPrefix:{value:values.JobPrefix},
          type:{value:values.type},
        }
      }
    })
  }

let colors= ["#0e86d4","#db1f48", "#76b947", "#bcece0", "#fad02c", "#01949a"]

  const initialvalue =useMemo(()=>{
    
    return{
      type:lazyState?.filters?.type?.value ? lazyState?.filters?.type?.value : "",
      JobPrefix:lazyState?.filters?.JobPrefix?.value ? lazyState?.filters?.JobPrefix?.value : "",
      JobCreationStartDate:lazyState?.filters?.JobCreationStartDate?.value ? formatDateTOYYYYMMDD(lazyState?.filters?.JobCreationStartDate?.value) : "",
      JobCreationEndDate:lazyState?.filters?.JobCreationEndDate?.value ? formatDateTOYYYYMMDD(lazyState?.filters?.JobCreationEndDate?.value) : "",
    }
  },[lazyState]) 

  const callBackFunction = useCallback((lazyData:any)=>{
    let modifiedLazyData = {
      ...lazyData,
      filters: {
        ...lazyData.filters,
        type:{value:"",matchMode:"contains"},
        JobPrefix:{value:lazyData.filters.JobPrefix?.value == "all" ? "" :lazyData.filters.JobPrefix?.value,matchMode:"contains"},
      },
    }
    dispatch(getJobsheetTatLoading(modifiedLazyData))
  },[])

  useEffect(()=>{
    callBackFunction(lazyState)
  },[lazyState])

  const ThreeDaysFilter = (days:any) =>{
    setFilteredTableData([])
    setFilteredChartData([])
    setOpenFor({
      mount:false,
      dealer:false,
      supplier:false,
      courier:false,
      nonpending:false,
      open:false,
      closed:false,
      totalClose:true,
    })
    let today  = new Date()
    let dateBefore = new Date(today.getTime() - days * 24 * 60 * 60 * 1000);
    setLazyState((state:any) => ({
      ...state,
      filters: {
        ...state.filters,
        JobCreationStartDate: { value: formatDateTOYYYYMMDD(dateBefore), matchMode: "contains" },
        JobCreationEndDate: { value: formatDateTOYYYYMMDD(today), matchMode: "contains" },
      },
    }))
  }
  
  const handleReset = (resetForm:any) =>{
    resetForm(initialvalue)
    setFilteredTableData([])
    setFilteredChartData([])
    setOpenFor({
      mount:false,
      dealer:false,
      supplier:false,
      courier:false,
      nonpending:false,
      open:false,
      closed:false,
      totalClose:true,
    })
    let today  = new Date()
    let dateBefore = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
    setTatStatus("all")
    setLazyState((state:any) => ({
      ...state,
      filters: {
        ...state.filters,
        type:{ value: "all", matchMode: "contains" },
        JobPrefix:{ value: "all", matchMode: "contains" },
        JobCreationStartDate: { value: formatDateTOYYYYMMDD(dateBefore), matchMode: "contains" },
        JobCreationEndDate: { value: formatDateTOYYYYMMDD(today), matchMode: "contains" },
      },
    }))
  }

  const jobPrefixOptions = useMemo(()=>{
    let data = jobPrefixList?.map((item:any)=>({label:item.jobPrefix,value:item.jobPrefix}))
    return [
      {label:"All",value:"all"},
      ...data
    ]
  },[jobPrefixList])
  
  return (
    <React.Fragment>
      <Col xl={12}>
        <Card className="card-h-100">
          <CardBody>
            <div className="d-flex flex-wrap align-items-center mb-4">
              <h5 className="card-title me-2">Jobsheet Tat</h5>
              <div className="ms-auto">
                <div>
                  <b>{date}</b>
                </div>
              </div>
            </div>
            <Row className="align-items-center">
              <div className="d-flex w-100 flex-wrap" style={{justifyContent:"space-between",alignItems:"center"}}>
                <div className="" style={{width:"70%",minWidth:"800px"}}>
                <Formik
                  onSubmit={handleSubmit}
                  initialValues={initialvalue}
                  enableReinitialize
                >
                  {({
                    values,
                    handleChange,
                    touched,
                    errors,
                    handleBlur,
                    resetForm,
                    reset,
                    isSubmitting,
                    ...rest
                  }: any) => {
                    return (
                      <Form onChange={handleChange}>
                        <Row>
                          <Col lg={2} md={4} sm={12}>
                            <DropdownInput
                              options={[
                                { label: "All", value: "all" },
                                { label: "Open Call", value: "openCall" },
                                { label: "Closed Call", value: "closedCall" },
                              ]}
                              name="type"
                              label="Type"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              required={false}
                              value={values.type}
                              invalid={
                                touched["type"] && errors["type"] ? true : false
                              }
                            />
                          </Col>
                          <Col lg={2} md={4} sm={12}>
                            <DropdownInput
                              options={jobPrefixOptions}
                              name="JobPrefix"
                              label="Job Prefix"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              required={false}
                              value={values.JobPrefix}
                              invalid={
                                touched["JobPrefix"] && errors["JobPrefix"] ? true : false
                              }
                            />
                          </Col>
                          <Col lg={2} md={4} sm={12}>
                            <label htmlFor="JobCreationStartDate">From</label>
                            <Input
                              type="date"
                              required
                              name={"JobCreationStartDate"}
                              value={values.JobCreationStartDate}
                              onBlur={handleBlur}
                              max={values?.JobCreationEndDate ? values?.JobCreationEndDate : ""}
                              onChange={handleChange}
                              invalid={false}
                            />
                          </Col>
                          <Col lg={2} md={4} sm={12}>
                            <label htmlFor="from">To</label>
                            <Input
                              type="date"
                              required
                              name={"JobCreationEndDate"}
                              value={values.JobCreationEndDate}
                              onBlur={handleBlur}
                              min={values?.JobCreationStartDate ? values?.JobCreationStartDate : ""}
                              onChange={handleChange}
                              invalid={false}
                            />
                          </Col>
                          <Col lg={2} md={4} sm={12} className="align-self-end">
                          <div className="d-flex">
                          <Button
                              className="secondary-btn me-2"
                              label={"Reset"}
                              type="button"
                              onClick={() => handleReset(resetForm)}
                            />
                            <Button
                              className="btn-primary btn-primary-shadow"
                              label={"Search"}
                              type="submit"
                            />
                          </div>
                          </Col>
                        </Row>
                      </Form>
                    );
                  }}
                </Formik>
                </div>
                <div className="d-flex">
        <UIButton
          label={"Last 7 Days"}
          className={`btn-primary ms-2`}
          type="button"
          onClick={() => {ThreeDaysFilter(7)}}
          disabled={false}
        ></UIButton>
        <UIButton
          label={"Last 15 Days"}
          className={`btn-primary ms-2`}
          type="button"
          onClick={() => {ThreeDaysFilter(15)}}
          disabled={false}
        ></UIButton>
        <UIButton
          label={"Last 30 Days"}
          className={`btn-primary ms-2`}
          type="button"
          onClick={() => {ThreeDaysFilter(30)}}
          disabled={false}
        ></UIButton>
        </div>
              </div>
              <div className="chart-data">
              <Row>
                <Col lg={12}>
                <div className="d-flex flex-wrap mb-3 gap-2 mt-3">
                {
                    dummyData?.map((item:any, index:any)=>(
                      <div className={`data-card ${item?.active ? "card-border" : ""}`} key={index} onClick={item.onClick ? item.onClick : ()=>{}} style={{cursor:item.onClick ? "pointer" : "default"}}>
                        <div className="d-flex flex-column justify-content-center align-items-start">
                        <div className="data-header">{item.name}</div>
                        <div className="data-body">{item.count}</div>
                        </div>
                        <div className="icon" style={{backgroundColor:colors[index]}}>
                        <i className={`bx ${item.icon}`}></i>
                        </div>
                      </div>
                    ))
                }
                </div>
                </Col>
                <Col lg={4} className="mt-3">
              <ReactApexChart
              key={key}
                options={options}
                series={chartSeries}
                type="bar"
                height={400}
                />
                </Col>
                <Col lg={8} className="mt-3">
                   <div className="card ps-0 pe-0 dashboard-table" id="table-border">
                    
                      <DataTable
                       size="large"
                       value={filteredTableData.length > 0 ? filteredTableData : jobTatValue}
                       showGridlines
                       lazy
                       scrollable
                       scrollHeight="400px"
                       tableStyle={{ minWidth: '50rem',maxHeight:"500px" }}
                      >
                        <Column field="jobNumber" header="Job No" className='table-font'
                        body={(rowData:any)=>{
                          if(rowData.jobId){
                            return <Link to={`${ROUTER.JOB_SHEETS_VIEW}/${rowData.jobId}`}>{rowData.jobNumber ? rowData.jobNumber : "WIP"}</Link>
                          }else{
                            return rowData.jobNumber
                          }
                        }}
                        ></Column>
                        <Column field="jobNumber" header="Job Type" className='' body={(rowData:any)=>{
                          if(rowData.isExchange && rowData.technicianUserType != "Franchise"){
                            return <div style={{backgroundColor:"#EF476F",color:"white",textAlign:"center",borderRadius:"5px",fontWeight:"500"}}>Exchange</div>
                          }
                          else if(rowData.technicianUserType == "Franchise" || rowData.jobType == "Remote"){
                            return <div style={{backgroundColor:"#0edf7f",color:"white",textAlign:"center",borderRadius:"5px",fontWeight:"500"}}>Field</div>
                          }
                          else if((rowData.jobType== "InHouse" || !rowData.jobType) && rowData.technicianUserType != "Franchise"){
                            return <div style={{backgroundColor:"#4B9FE1",color:"white",textAlign:"center",borderRadius:"5px",fontWeight:"500"}}>In House</div>
                          }
                        }}></Column>
                        <Column field="dealerTat" header="Dealer Tat" className='partSku table-font' body={(rowData:any)=> convertTimesToSeconds(rowData?.dealerTat)}></Column>
                        <Column field="supplierTat" header="Supplier Tat" className='partSku table-font' body={(rowData:any)=>convertTimesToSeconds(rowData?.supplierTat)}></Column>
                        <Column field="melTat" header="Mel Tat" className='partSku table-font' body={(rowData:any)=>convertTimesToSeconds(rowData?.melTat)}></Column>
                        <Column field="courierTat" header="Courier Tat" className='partSku table-font' body={(rowData:any)=>convertTimesToSeconds(rowData?.courierTat)}></Column>
                      </DataTable>
                    </div>
                </Col>
                </Row>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default JobsheetTat;
